import http from '../../config/http-common';
import ui from "@/assets/scripts/ui";
import FlowStepRuleActionType from "@/model/types/modules/production/FlowStepRuleActionType";
import TypeNonConformanceService from "@/services/modules/production/TypeNonConformance.service";

//Usado somente se for realmente necessário algo fora do padrão GeneralCRUD.service.js
const path = "production/order-step"

class service {

    action(type_action, id, goProductionOrderBatchStepId = 0, typeStopId = 0, stopNote = '') {

        const action = {
            action: type_action,
            productionOrderBatchStepId: id,
            goProductionOrderBatchStepId,
            typeStopId,
            stopNote,
        }

        return http.post(path + "/action", action).then(response => response.data);

    }

    async checkRules(state,form,onSubmitContinued,openAgainCallback,removeStatus,setAlternativeChosen,setTypeNonConformanceChosen) {

        return http.post(path + "/checkRules", form).then(async response => {

            if (response.data.hasError) {
                removeStatus()
                await this.validateRules(state,response.data, form, onSubmitContinued,openAgainCallback,setAlternativeChosen,setTypeNonConformanceChosen)
            } else {
                onSubmitContinued()
            }

        }).catch(error => ui.generalResponseError(this,error));
    }

    copyData(productionOrderBatchStepId, productionOrderId) {
        return http.get(path + "/copyData/?productionOrderBatchStepId=" + productionOrderBatchStepId + "&productionOrderId=" + productionOrderId)
    }

    selectStopProductionRelationList(productionOrderBatchStepId) {

        let params = new URLSearchParams()
        params.set("productionOrderBatchStepId", productionOrderBatchStepId)

        return http.list(path + "/selectStopProductionRelationList", params)
    }


    async validateRules(state,response,form,onSubmitContinued,openAgainCallback,setAlternativeChosen,setTypeNonConformanceChosen){

        let typeNonConformanceOptions = []

        await TypeNonConformanceService.selectList().then((options) => {
            typeNonConformanceOptions = options
        }).catch(error => ui.generalResponseError(state,error))


        const rule = response.rule



        let msgConfirm = '<b>' + rule.name + "</b>: <br />"


        for (const alert of rule.alertErrorsField) {
            msgConfirm += `- ${alert.field} : ${alert.error}<br />`
        }


        if (rule.goStep !== undefined && rule.goStep !== null && rule.goStep !== '') {
            msgConfirm += "<br />Caso continuar irá para etapa: <br /><b>" + rule.goStep + "</b>"
        }

        if (rule.statusProduction !== undefined && rule.statusProduction !== null && rule.statusProduction !== '') {
            msgConfirm += "<br />Caso continuar altera o status para: <br /><b>" + rule.statusProduction + "</b>"
        }

        if (rule.typeActionRule === FlowStepRuleActionType.type.ALTERNATIVES) {

            msgConfirm += "<div class=\"card main-card alert-warning m-2 p-2\">"

            msgConfirm += "<div class=\"card-title mb-0\">" + rule.question + "</div>"

            for (const alternative of rule.alternatives) {

                msgConfirm += "<div class=\"position-relative form-check\">" +
                    "<label class=\"form-check-label\">" +
                    "<input name=\"alternativeChosen\" type=\"radio\" value='" + alternative.value + "' class=\"form-check-input\"> " + alternative.text + "   </label>" +
                    "</div>"

            }


            msgConfirm += "<br /><br /><small>Escolha uma alternativa</small></div>"

        }

        if (rule.requiredTypeNonConformance) {

            msgConfirm += "<div class=\"card main-card alert-warning m-2 mb-0 p-2\">"

            msgConfirm += "<div class=\"card-title mb-0\">Escolha um tipo de não conformidade geral</div>"

            msgConfirm += "<select id=\"typeNonConformanceChosen\" style=\"background-color:white\" class=\"form-control\">"

            msgConfirm +=
                "<option value='0'>Selecione</option>"

            for (const item of typeNonConformanceOptions) {

                if (form.typeNonConformanceId === item.value) {

                    msgConfirm +=
                        "<option selected value='" + item.value + "'>" + item.text + "</option>"

                } else {
                    msgConfirm +=
                        "<option value='" + item.value + "'>" + item.text + "</option>"
                }

            }

            msgConfirm += "</select></div>"

        }

        if (rule.typeActionRule === FlowStepRuleActionType.type.INFO) {
            msgConfirm += rule.info
            msgConfirm += "<br />Obs.: Este é somente um lembrete, não haverá bloqueio ou impedimento de continuidade, deseja continuar mesmo assim?"
        } else {
            msgConfirm += "<br /><br />Obs.: Está é a não conformidade de maior prioridade encontrada"
        }

        if (rule.typeActionRule === FlowStepRuleActionType.type.INFO) {
            ui.msgConfirm(state, "Informação", msgConfirm, async () => {
                await onSubmitContinued()
            })
        } else if (rule.typeActionRule === FlowStepRuleActionType.type.BLOCK) {
            msgConfirm += ", NÃO será permitido continuar até correção do valor."

            ui.msgError(state, msgConfirm, null, "Não conformidade encontrada")

        } else {

            ui.msgConfirm(state, "Não conformidade encontrada", msgConfirm, async () => {

                let typeNonConformanceChosen = await this.getTypeNonConformanceChosen(state,rule.requiredTypeNonConformance,openAgainCallback)
                let checkTypeNonConformance = true

                if (rule.requiredTypeNonConformance && typeNonConformanceChosen === 0) {
                    //Exigido escolha de tipo de não conformidade e a mesma não foi selecionada
                    checkTypeNonConformance = false
                } else if (rule.requiredTypeNonConformance && typeNonConformanceChosen > 0) {
                    //Exigido e escolhido corretamente
                    setTypeNonConformanceChosen(typeNonConformanceChosen)
                }

                if (!checkTypeNonConformance)
                    return false;//Pausa continuidade,pois já encontrou erro


                let alternativeChosen = await this.getAlternativeChosen(state,rule.typeActionRule,openAgainCallback)
                let checkAlternative = true

                if (rule.typeActionRule === FlowStepRuleActionType.type.ALTERNATIVES && alternativeChosen === 0) {
                    //Tipo de escolha de alternativas e não escolhida uma alternativa
                    checkAlternative = false
                } else if (rule.typeActionRule === FlowStepRuleActionType.type.ALTERNATIVES && alternativeChosen > 0) {
                    setAlternativeChosen(alternativeChosen)
                }

                if (!checkAlternative)
                    return false;//Pausa continuidade,pois já encontrou erro


                await onSubmitContinued()

            })

        }

    }


    async getTypeNonConformanceChosen(state,requiredTypeNonConformance,openAgainCallback) {

        let chosen = 0

        if (requiredTypeNonConformance) {

            const object = document.getElementById("typeNonConformanceChosen");
            const checked = object.value

            if (checked !== null && checked !== undefined) {
                chosen = parseInt(object.value)
            }

            if (chosen === 0) {
                ui.msgError(state, 'Para continuar é necessário que você escolha o tipo de não conformidade geral desta ordem de fabricação', () => {
                    openAgainCallback()
                    //this.sendingForm()
                }, "Escolha um tipo de não conformidade")

            }

        }

        return chosen

    }

    async getAlternativeChosen(state,typeActionRule,openAgainCallback) {

        let chosen = 0

        if (typeActionRule === FlowStepRuleActionType.type.ALTERNATIVES) {

            const array = document.getElementsByName("alternativeChosen");
            const checked = Array.from(array).find(radio => radio.checked);

            if (checked !== null && checked !== undefined) {
                chosen = parseInt(checked.value)
            }

            if (chosen === 0) {
                ui.msgError(state, 'Para continuar é necessário que você realize uma escolha entre as alternativas', () => {
                    openAgainCallback()
                    //this.sendingForm()
                }, "Escolha uma alternativa")
            }

        }

        return chosen
    }






}

export default new service();


